import React from 'react'

interface LastPhotoSvgProps {
  className?: string
  size?: number
}

export const LastPhotoSvg = ({ className, size = 124 }: LastPhotoSvgProps) => (
  <svg className={className} width={size} height={size} viewBox="0 0 124 124">
    <g fill="none" fillRule="evenodd">
      <g>
        <path
          fill="#E06065"
          d="M9.939 101.098h78.965c2.762 0 5-2.239 5-5V47.046H4.94v49.052c0 2.761 2.238 5 5 5z"
          transform="translate(12)"
        />
        <path
          fill="#C53D43"
          d="M55.703 54.166s-.127-1.532 2.667-1.532c2.795 0 2.287 4.086 2.287 4.086s-2.287 25.924-2.414 46.612c0 0 .048 1.508-1.627 1.584-1.676.076-3.708-4.905-3.962-6.437s3.049-44.313 3.049-44.313"
          transform="translate(12)"
        />
        <path
          fill="#FDC85C"
          d="M69.927 3.177l-20.85 13.677L28.27 3.138c-2.306-1.52-5.407-.883-6.927 1.423-.071.108-.138.219-.201.332l-7.607 13.761c-1.069 1.934-.368 4.367 1.566 5.436.598.33 1.272.503 1.956.5l64.056-.334c2.21-.011 3.99-1.811 3.98-4.02-.004-.682-.182-1.35-.516-1.944l-7.551-13.39c-1.356-2.406-4.406-3.256-6.811-1.9-.098.055-.193.114-.287.175z"
          transform="translate(12)"
        />
        <path
          fill="#FED576"
          d="M.308 59.604h98.215V27.052c0-1.546-1.253-2.8-2.8-2.8H3.108c-1.547 0-2.8 1.254-2.8 2.8v32.552zM19.713 21.253s-4.13-.11-3.043-2.84c1.087-2.733 6.413-12.457 6.413-12.457s.87-1.53 2.065-.218c1.196 1.31-1.521 16.498-5.435 15.515M73.778 6.514s-.184-.965.628-1.262c.812-.297 1.403.965 1.403.965s6.497 11.43 7.531 13.507c1.034 2.079-3.544 3.043-4.43.891-.886-2.152-4.356-10.539-5.132-14.101"
          transform="translate(12)"
        />
        <path
          fill="#FDC85C"
          d="M52.675 24.369V59.72h5.464L56.313 24.37h-3.638z"
          transform="translate(12)"
        />
        <path
          fill="#FED576"
          d="M42.922 104.916L55.909 104.916 55.909 24.197 42.922 24.197z"
          transform="translate(12)"
        />
        <path
          fill="#FEEABD"
          d="M44.286 27.845s-.339-3.427 1.27-3.51c1.61-.084 7.707 0 7.707 0s1.61-.167 1.44 1.003c-.17 1.17-10.332 5.85-10.417 2.507"
          transform="translate(12)"
        />
      </g>
      <g>
        <path
          fill="#5D6BB0"
          d="M67.26 36.462s-2.596-13.885 13.885-14.275c16.482-.389 26.289.26 26.289.26s13.237.13 11.29 10.512c0 0-.908 5.58-4.023 9.214 0 0 4.672 4.671 5.97 7.656 0 0 0 1.038-1.687.779-1.687-.26-7.916-2.596-17-2.855-9.085-.26-18.373.778-18.373.778S69.206 50.348 67.26 36.462"
          transform="translate(0 73)"
        />
        <path
          fill="#3F4A83"
          d="M91.247 43.268c11.371.578 15.034-1.927 17.732-8.48 1.544-3.75 2.835-8.255 3.657-11.425-2.68-.891-5.202-.916-5.202-.916s-9.808-.649-26.289-.26c-16.48.39-13.885 14.275-13.885 14.275.362 2.584 1.156 4.624 2.208 6.233 3.403.019 12.713.112 21.78.573"
          transform="translate(0 73)"
        />
        <path
          fill="#4ECFA8"
          d="M1.054 23.99c2.668-3.669 4.064-5.367 4.064-5.367s2.218-2.208 1.934-5.838c-.356-4.551.789-7.753 3.534-9.675C13.33 1.188 15.62.86 21.922.931c6.301.071 45.268-.094 60.071-.335 17.873-.29 20.19 2.548 20.19 2.548s7.378 2.797 4.818 16.787c-2.63 14.377-5.921 16.908-5.921 16.908s-1.717 3.296-11.095 2.99c-9.378-.305-36.855-.598-52.565-.037-15.71.562-18.716-1.816-22.102-9.035 0 0-1.684-5.956-6.818-4.782-5.135 1.174-6.876 1.117-6.876 1.117s-3.238.565-.57-3.103z"
          transform="translate(0 73)"
        />
        <path
          fill="#FFF"
          d="M91.594 18.288H31.406c-.777 0-1.406-.193-1.406-.43v-3.063c0-.238.63-.431 1.406-.431h60.188c.777 0 1.406.193 1.406.43v3.063c0 .238-.63.431-1.406.431M75.594 26.16H31.406c-.776 0-1.406-.193-1.406-.431v-3.063c0-.238.63-.431 1.406-.431h44.188c.777 0 1.406.193 1.406.431v3.063c0 .238-.63.43-1.406.43"
          transform="translate(0 73)"
        />
      </g>
    </g>
  </svg>
)
